export const ADD_SCHOR_HORIZONTAL = "ADD_SCHOR_HORIZONTAL"
export const EDIT_SCHOR_HORIZONTAL = "EDIT_SCHOR_HORIZONTAL"
export const LIST_SCHOR_HORIZONTAL = "LIST_SCHOR_HORIZONTAL"
export const VIEW_SCHOR_HORIZONTAL = "VIEW_SCHOR_HORIZONTAL"
export const DELETE_SCHOR_HORIZONTAL = "DELETE_SCHOR_HORIZONTAL"

// Text
export const ADD_SCHOR_HORIZONTAL_TEXT = "ADD_SCHOR_HORIZONTAL_TEXT"
export const EDIT_SCHOR_HORIZONTAL_TEXT = "EDIT_SCHOR_HORIZONTAL_TEXT"
export const LIST_SCHOR_HORIZONTAL_TEXT = "LIST_SCHOR_HORIZONTAL_TEXT"
export const VIEW_SCHOR_HORIZONTAL_TEXT = "VIEW_SCHOR_HORIZONTAL_TEXT"
export const DELETE_SCHOR_HORIZONTAL_TEXT = "DELETE_SCHOR_HORIZONTAL_TEXT"

export const SCHOR_HORIZONTAL_SUCCESS = "SCHOR_HORIZONTAL_SUCCESS"
export const SCHOR_HORIZONTAL_ERROR = "SCHOR_HORIZONTAL_ERROR"

